import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling
import { Link } from 'react-router-dom'; // Import Link from react-router-dom



function KSACORS() {
  const { t } = useTranslation(); // Hook for translation
  
  

  return (
    <div >
    {/* Hero Section */}
    <div className="hero-banner">
      <div className="hero-content" >
        <h1 style={{ color: 'black' }}>{t('ksa_cors_title')}</h1>
        
      </div>
      
    </div>
    
    

    {/* Content Section */}
    <div className="hero-banner" style={{ backgroundColor: 'white' }}>
        <div className="hero-content">
          
          <p style={{ textAlign: 'justify' }}>{t('ksa_cors_sub1')}</p>
          <p style={{ textAlign: 'justify' }}>{t('ksa_cors_sub2')}</p>
          <p style={{ textAlign: 'justify' }}>{t('ksa_cors_sub3')}</p>
          <p style={{ textAlign: 'justify' }}>{t('ksa_cors_sub4')}
          <ul>
          <li style={{ textAlign: 'justify' }}>{t('ksa_cors_sub5')}</li>
          <li style={{ textAlign: 'justify' }}>{t('ksa_cors_sub6')}</li>
          </ul></p>
          <p style={{ textAlign: 'justify' }}>{t('ksa_cors_sub7')}
          <ul>
          <li style={{ textAlign: 'justify' }}>{t('ksa_cors_sub8')}</li>
          <li style={{ textAlign: 'justify' }}>{t('ksa_cors_sub9')}</li>
          </ul></p>
          <p style={{ textAlign: 'justify' }}>{t('ksa_cors_sub10')}
          <ul>
          <li style={{ textAlign: 'justify' }}>{t('ksa_cors_sub11')} <a  href="https://ksacors.geoportal.sa" target="_blank" rel="noopener noreferrer">
                  {t('KSA-CORS')}
                </a></li>
          <li style={{ textAlign: 'justify' }}>{t('ksa_cors_sub12')}</li>
          <li style={{ textAlign: 'justify' }}>{t('ksa_cors_sub13')}</li>
          <li style={{ textAlign: 'justify' }}>{t('ksa_cors_sub14')} <a
              href={`mailto:${t('email_address')}`}
              target="_blank"
              rel="noopener noreferrer"
             
            > info@geosa.gov.sa</a></li>
          <li style={{ textAlign: 'justify' }}>{t('ksa_cors_sub15')}</li>
          </ul></p>
          <p style={{ textAlign: 'justify' }}>{t('ksa_cors_sub16')}</p>
          <p style={{ textAlign: 'justify' }}>{t('ksa_cors_sub17')}</p>
          <p style={{ textAlign: 'justify' }}>{t('ksa_cors_sub18')}</p>
          


          <p style={{ textAlign: 'justify' }}> 
          <a href={t('ksa_cors_sub19_url')} download> {t('ksa_cors_sub19')}
          </a>
            
           </p>
          <p style={{ textAlign: 'justify' }}>  
            <a href={t('ksa_cors_sub20_URL')} download> 
                  {t('ksa_cors_sub20')}
                </a></p>
                <p style={{ textAlign: 'justify' }}>  
            <a href="/pdf/How_to_Register_to_KSA-CORS_Network_v.1.0.pdf" download> 
                  {t('ksa_cors_sub21')}
                </a></p>
          
          <br />          
        </div>
      </div>
      <div className="cards-space" style={{height:"40px"}}></div>
      
      <section class="services"style={{padding:"1rem"}}>
    <p style={{ textAlign: 'justify' }}>
    
    <Link to="/Geodesy/KSACors/FAQ">{t('faq_title')}</Link> </p>
      
    </section>
 
    
    </div>
);
}

export default KSACORS;
